// Generated by scripts/sportsbook_history/generate.mjs
import Services from "./Services";

export class GamesService extends Services {
  constructor(init) {
    super(init);
    this._name = "GAMESSERVICE";
  }

  bettingHistory = async (params, { signal } = {}) =>
    await this.decorate(
      async () =>
        await this.axios("/bet", {
          method: "GET",
          params,
          signal,
        })
    );
}

export default GamesService;
